<script lang="ts">
  import type { ClassValue } from 'svelte/elements';

  interface Props {
    title: string;
    class?: ClassValue;
    legendClass?: ClassValue;
    error?: string[] | string;
    children?: import('svelte').Snippet;
  }

  let { title, legendClass, class: _class, error, children }: Props = $props();
</script>

<fieldset class={['fieldset', _class]}>
  <span class={['fieldset-legend', legendClass]}>{title}</span>
  {@render children?.()}
  {#if error}
    <p class="label text-error text-sm">{error}</p>
  {/if}
</fieldset>
